<script setup lang="ts">

interface Props{
  icon?: string;
  loading?: boolean;
  clearable?: boolean;
  disabled?: boolean;
}

withDefaults(defineProps<Props>(), {
  icon: '',
  loading: false,
  clearable: false,
  disabled: false
});

const emit = defineEmits<{
  clear: []
}>();

const { t } = useEkI18n();

</script>

<template>
  <IonItem
    lines="full"
    :detail="false"
    :disabled="disabled || loading"
  >
    <IonSpinner
      v-if="loading"
      slot="start"
      color="dark"
    />

    <IonIcon
      v-else
      slot="start"
      color="dark"
      class="fa-fw"
      style="margin-inline-end: 16px;"
      :class="icon"
    />

    <IonLabel v-if="loading">
      {{ t('loading.loading') }}
    </IonLabel>
    <slot v-else />

    <IonButton
      v-if="clearable && !loading && !disabled"
      slot="end"
      fill="clear"
      class="clear-button"
      size="small"
      @click.stop="emit('clear')"
    >
      <IonIcon
        slot="icon-only"
        class="fa-fw fa-light fa-xmark"
      />
    </IonButton>
  </IonItem>
</template>

<style scoped>

ion-item::part(native){
    min-height: 3.5rem;
}

ion-icon {
  --font-size: 1.5rem;
}

ion-item {
  --padding-end: 0.5rem;
  --padding-start: 0.3rem;
}
.clear-button{
    color: var(--ion-color-step-600);
    width: 2rem;
    margin-right: 0rem;
}

ion-spinner {
    margin-right: 2.3rem !important;
}
</style>
